import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DxDataGridModule, DxNumberBoxModule, DxDateBoxModule , DxBulletModule, DxTemplateModule, DxButtonModule, DxCheckBoxModule, DxFileUploaderModule } from 'devextreme-angular';




@NgModule({
  exports:[
    DxDataGridModule, DxNumberBoxModule, DxDateBoxModule , DxBulletModule, DxTemplateModule, DxButtonModule, DxCheckBoxModule, DxFileUploaderModule
  ],
  declarations: [],
  imports: [
    CommonModule,
    DxDataGridModule, DxNumberBoxModule, DxDateBoxModule , DxBulletModule, DxTemplateModule, DxButtonModule, DxCheckBoxModule, DxFileUploaderModule
  ]
})
export class DevExtremeModule { }
